import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { Icon } from "@/libraries/wpl/foundations/src";

const featureListTeam24 = [
    <FormattedMessage
        id="JiraSoftwarePricingPageTemplate.dataCenterCalculator.features-freeFor30Days"
        defaultMessage="Free for 30 days"
        key={0}
    />,
    <FormattedMessage
        id="JiraSoftwarePricingPageTemplate.dataCenterCalculator.features-completeControl"
        defaultMessage="Complete control of your environment"
        key={1}
    />,
    <FormattedMessage
        id="JiraSoftwarePricingPageTemplate.dataCenterCalculator.features-activeClustering"
        defaultMessage="Active clustering for high availability"
        key={2}
    />,
    <FormattedMessage
        id="JiraSoftwarePricingPageTemplate.dataCenterCalculator.features-annualTerm"
        defaultMessage="Annual term license + maintenance"
        key={3}
    />,
    <FormattedMessage
        id="JiraSoftwarePricingPageTemplate.dataCenterCalculator.features-optimizedForAWSorAzure"
        defaultMessage="Optimized for AWS or Azure deployment"
        key={4}
    />,
    <FormattedMessage
        id="JiraSoftwarePricingPageTemplate.dataCenterCalculator.features-SAMLandOpenID"
        defaultMessage="SAML 2.0 and OpenID Connect support"
        key={5}
    />,
    <FormattedMessage
        id="JiraSoftwarePricingPageTemplate.dataCenterCalculator.features-atlassianSupportedDR"
        defaultMessage="Atlassian-supported disaster recovery"
        key={6}
    />,
    <FormattedMessage
        id="JiraSoftwarePricingPageTemplate.dataCenterCalculator.features-projectAndIssueArchiving"
        defaultMessage="Project and issue archiving for improved performance"
        key={7}
    />
];

const featureItemStyle = css({
    fontSize: "1rem",
    lineHeight: "1.5",
    marginBlockEnd: "24px",
    paddingInlineStart: "4px"
});

const featureListStyle = css({
    ListStyleType: "disc",
    paddingInlineStart: "20px",
    listStyle: "none",
    marginBlockStart: "0"
});

const featureListItemStyle = css({
    marginInlineStart: "-20px",
    minHeight: "15px",
    position: "relative",
    marginBlockEnd: "12px",
    fontSize: "1rem",
    lineHeight: "1.5",
    display: "flex"
});

const checkmarkIconStyle = css({
    "position": "relative",
    "flex-shrink": "0"
});

export const ProductFeatureTeam24 = () => {
    return (
        <div>
            <ul css={featureListStyle}>
                {featureListTeam24.map((message, index) => (
                    <li key={index} css={featureListItemStyle}>
                        <div css={checkmarkIconStyle}>
                            <Icon
                                name="featurecheckmark"
                                size="xs"
                                color="g400"
                            />
                        </div>
                        <p css={featureItemStyle} key={index}>
                            {message}
                        </p>
                    </li>
                ))}
            </ul>
        </div>
    );
};
